import { render, staticRenderFns } from "./ResultSummary.vue?vue&type=template&id=29889f5f&scoped=true"
import script from "./ResultSummary.vue?vue&type=script&lang=js"
export * from "./ResultSummary.vue?vue&type=script&lang=js"
import style0 from "./ResultSummary.vue?vue&type=style&index=0&id=29889f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29889f5f",
  null
  
)

export default component.exports